module.exports = __webpack_public_path__ + "static/media/crunch.8f834309.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/accessory_image/toppings/crunch.jpg
// module id = 125
// module chunks = 0